export default function (val) {
  val = val || ''
  const a = `${val.replace(/\D/g, '')}`
  return !a.startsWith('1') && a.length === 10
}
